<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" v-if="!isVerifyLoading">
        <p class="font--p-3 mt-5" v-if="!isBuynowWooriCrowd">
          선정산과 대출금을 받으실 주거래 계좌를 알려주세요
        </p>
        <p class="font--p-3 mt-5" v-else>
          대출금을 받으실 주거래 계좌를 알려주세요
        </p>
        <label class="font-size--16">계좌번호</label>
        <v-text-field v-model="selBankNo" type="tel" v-input-restrict.number></v-text-field>
        <label class="font-size--16">은행</label>
        <v-autocomplete
          v-model="selBank"
          :items="banks"
          item-text="name"
          item-value="value"
          return-object
        ></v-autocomplete>
        <div v-if="holderName">
          <label class="font-size--16">예금주</label>
          <v-text-field v-model="holderName" disabled></v-text-field>
        </div>
        <BasicButton
          @click="checkOwnerName(withdrawalBank)"
          :loading="checkOwnerNameLoading"
          :disabled="checkOwnerNameLoading || !isValidBankNum"
        >
          계좌 인증하기
        </BasicButton>
        <!-- <v-btn to="/signup/documents">테스트</v-btn> -->
      </v-col>
      <v-col cols="12" class="mt-5" v-else>
        <p class="font--p-3 mt-5 mb-5">
          안전한 금융거래를 위하여 <br />
          등록한 계좌의 1원 인증을 해주세요
        </p>
        <div style="display: flex">
          <v-col cols="5">
            <v-select
              v-model="selBank"
              :items="banks"
              item-text="name"
              item-value="value"
              disabled
            ></v-select>
          </v-col>
          <v-col cols="7">
            <v-text-field v-model="selBankNo" disabled></v-text-field>
          </v-col>
        </div>
        <label class="font-size--16">
          등록된 계좌로 1원을 보내드렸습니다. <br />
          입금자로 표시된 숫자 4자리로 입력해주세요. <br />
          (저축은행 계좌의 경우 3자리로 입력해주세요)
        </label>
        <v-text-field
          v-model="verifyWord"
          type="tel"
          maxlength="4"
          class="mb-3"
          hide-details=""
          v-input-restrict.number
        ></v-text-field>
        <ExpireTime
          v-if="expireTime"
          :expire-date="expireTime"
          @emitTimeOver="isTimeOut"
          class="mb-3"
        >
        </ExpireTime>
        <BasicButton
          @click="sendVerifyWord(verifyWord)"
          :disabled="sendVerifyWordLoading"
          :loading="sendVerifyWordLoading"
        >
          인증번호 확인
        </BasicButton>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import ExpireTime from '@/components/bank/ExpireTime.vue'
import moment from 'moment'
import { redirectSignupManage } from '@/util/signupManage'
import { mapGetters } from 'vuex'

export default {
  components: {
    ExpireTime,
  },
  props: {
    me: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      banksObj: {},
      securities: [],
      selBank: null,
      selBankNo: null,
      holderName: null,
      tid: null,
      verifyWord: null,
      sendVerifyWordLoading: false,
      checkOwnerNameLoading: false,
      expireTime: null,
    }
  },
  computed: {
    ...mapGetters('myfinbiz', ['platformCode']),
    isValidBankNum() {
      return !!this.selBankNo && !!this.selBank?.value
    },
    banks() {
      const banks = []
      for (const k in this.banksObj) {
        banks.push({
          name: this.banksObj[k],
          value: k,
        })
      }
      return banks
    },
    withdrawalBank() {
      return {
        bank: this.selBank?.value,
        accountNumber: this.selBankNo,
      }
    },
    isVerifyLoading() {
      if (this.tid) {
        return true
      }
      return false
    },
    isExpireTimeOut() {
      if (this.expireTime) {
        return true
      } else {
        return false
      }
    },
    isBuynowWooriCrowd() {
      return this.platformCode === 'buynow-woori-crowd'
    },
  },
  watch: {
    tid(v) {
      if (v) {
        this.expireTime = moment().add(5, 'minutes').toDate()
      } else {
        this.expireTime = null
      }
    },
  },
  async created() {
    this.banksObj = await this.getBanks()
    this.setSelectBank()
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('choice', ['getBanks']),
    ...mapActions('fundaPaygate', ['getAccountHolderName']),
    ...mapActions('withdrawalAccount', ['updateWithdrawalAccount', 'confirmVerifyWord']),

    setSelectBank() {
      const { withdrawalAccount } = this.me
      this.selBank = {
        value: withdrawalAccount.bank,
        name: withdrawalAccount.accountName,
      }
      this.selBankNo = withdrawalAccount.accountNumber
    },
    async checkOwnerName(bank) {
      try {
        this.checkOwnerNameLoading = true
        const holderName = await this.getAccountHolderName(bank)
        if (holderName.indexOf(this.me.name) < 0) {
          await this.$swal.basic.error({
            html: '계좌 정보가 불일치 합니다.<br/>다시 확인 후 입력해주세요.',
          })
        } else {
          const { isConfirmed } = await this.$swal.basic.confirm({
            html: `예금주 : ${holderName}<br/>해당 계좌를 주거래 계좌로 등록합니다.`,
          })
          if (isConfirmed === true) {
            this.holderName = holderName
            this.tid = await this.updateWithdrawalAccount(
              Object.assign(this.withdrawalBank, {
                holderName,
              }),
            )
          }
        }
      } finally {
        this.checkOwnerNameLoading = false
      }
    },
    async sendVerifyWord(verifyWord) {
      try {
        this.sendVerifyWordLoading = true
        const { result, message } = await this.confirmVerifyWord(verifyWord)
        if (result === false && message) {
          await this.$swal.basic.error(message)
          return
        }
        await this.$swal.basic.success({
          html: '계좌 인증이 완료됐습니다.',
          confirmButtonText: '확인',
        })
        this.tid = null
        await this.getMe()
        if (await redirectSignupManage()) {
          return
        }
        await this.$router.push('/signup/documents')
      } finally {
        this.sendVerifyWordLoading = false
      }
    },
    async isTimeOut() {
      await this.$swal.basic.alert({
        html: '발급된 인증번호의 유효기간이 만료되었습니다. <br/> 다시 입력해주세요.',
      })
      this.tid = null
    },
  },
}
</script>
<style lang="scss" scoped></style>
